import { gql } from "../../../../../gql/__generated__/gql";

export const SIGN_UP_NEW_USER = gql(`
  mutation signUpNewUser($input: SignUpNewUserInput!) {
    signUpNewUser(input: $input)
  }
`);

export const SEND_PASSWORD_RESET_EMAIL = gql(`
  mutation sendPasswordResetEmail($email: String!) {
    sendPasswordResetEmail(email: $email)
  }
`);
